<template>
  <el-table v-loading="loading" :data="rows" border
            size="small"
            :max-height="maxHeight">
    <el-table-column label="客户姓名" prop="customerName" align="center"
                     min-width="90"
                     fixed />
    <!-- BUG-2026-971010：核对时按用友编码匹配，不按姓名。同名客户全国很多，
         按姓名去「预约服务」导出里计数会把不同的人数到一个人头上。
         注意用友编码一个档案一个：同一个人的研修班档案和普通人员档案，编码是不同的。
         ⚠️ 不要再加手机号列：2026-09-20 一度加过，当天用户要求只留用友编码——
         这个看板所有有权限的账号都能看能导出，一整列完整手机号会随 xlsx 流出系统。 -->
    <el-table-column label="用友编码" prop="customerCode" align="center" width="120" />
    <el-table-column label="身份" prop="levelName" align="center" width="80" />
    <el-table-column label="加入大客户时间" align="center" width="150">
      <template slot-scope="{row}">
        {{ row.startAt }}
        <!-- big_start_time 为空的按设为大客户的操作时间起算，标出来免得对不上账 -->
        <el-tooltip v-if="row.startFromOperated" content="未记录加入时间，按设为大客户的操作时间起算" placement="top">
          <i class="el-icon-warning-outline" style="color:#E6A23C" />
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="大客户带教老师" prop="bigTeacherName" align="center" width="110" />
    <el-table-column v-if="showScanSignIns" label="扫码签到技术老师姓名（签到时间）" prop="scanSignIns"
                     min-width="300" header-align="center" align="left">
      <template slot-scope="{row}">
        <div v-if="Array.isArray(row.scanSignIns) && row.scanSignIns.length">
          <div v-for="(signIn, index) in row.scanSignIns" :key="index" class="scan-sign-in">
            {{ signIn.teacherName || '未记录' }}（{{ signIn.signInTime || '未记录' }}）
          </div>
        </div>
        <span v-else>—</span>
      </template>
    </el-table-column>
    <el-table-column label="是否子账号" align="center" width="90">
      <template slot-scope="{row}">{{ row.isSub ? '是' : '否' }}</template>
    </el-table-column>
    <el-table-column label="主账号姓名" prop="mainName" align="center" width="100" />
    <el-table-column label="省市区" align="center" min-width="150">
      <template slot-scope="{row}">{{ [row.provinceName, row.cityName, row.districtName].filter(Boolean).join('') }}</template>
    </el-table-column>
    <el-table-column :label="rangeMode ? '目前余额（实时）' : '目前余额'" prop="balance" align="center" width="110" />
    <el-table-column :label="rangeMode ? '区间服务次数' : '本月服务次数'" :prop="rangeMode ? 'periodSignCount' : 'monthSignCount'" align="center" width="100" />
    <el-table-column :label="rangeMode ? '区间业绩（全量）' : '月平均业绩（全量）'" :prop="rangeMode ? 'periodPerfAll' : 'avgPerfAll'" align="center" width="140">
      <template slot="header">
        {{ rangeMode ? '区间业绩（全量）' : '月平均业绩（全量）' }}
        <el-tooltip :content="rangeMode ? '所选区间内、加入大客户后的折算业绩合计：余额/现金 + 零售价×0.5 + 学费×2/3' : '自加入大客户起：Σ(余额/现金 + 零售价×0.5 + 学费/0.75×0.5) ÷ 月数，不足一月按 1'" placement="top"><i class="el-icon-question" /></el-tooltip>
      </template>
    </el-table-column>
    <el-table-column :label="rangeMode ? '区间业绩（不含联创/IP）' : '月平均业绩（不含联创/IP）'" :prop="rangeMode ? 'periodPerfExcluded' : 'avgPerfExcluded'" align="center" width="160">
      <template slot="header">
        {{ rangeMode ? '区间业绩（不含联创/IP）' : '月平均业绩（不含联创/IP）' }}
        <el-tooltip content="同左，但剔除商品分类「IP系列 / 联创品牌 / 联创」下的商品" placement="top"><i class="el-icon-question" /></el-tooltip>
      </template>
    </el-table-column>
    <el-table-column v-if="!rangeMode" label="起算月数" prop="months" align="center" width="80" />
  </el-table>
</template>

<script>
/**
 * 「3.0 客户明细」的表格本体（REQ-2026-107511）
 * 明细页签和周报点开的弹窗共用；扫码签到明细仅在客户明细页签启用。
 */
export default {
  name: 'BigDetailTable',
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    rangeMode: { type: Boolean, default: false },
    showScanSignIns: { type: Boolean, default: false },
    maxHeight: { type: [Number, String], default: undefined }
  }
}
</script>

<style scoped>
.scan-sign-in { white-space: normal; overflow-wrap: anywhere; line-height: 1.7; }
.scan-sign-in + .scan-sign-in { margin-top: 6px; }
</style>
